import { type FC, useMemo } from "react";

import { SmartLink } from "../../SmartLink.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";
import { getPlaybookEventResourcesSummary } from "@/app-utils/playbook.ts";
import { pluralizeWord } from "@/app-utils/string.ts";
import { type PlaybookEvent } from "@/graphql.ts";
import { SUBROW_HEIGHT } from "@/settings/settings.js";
import { EventResourcePopover } from "@/ui-modules/core/grid/cells/popovers/EventResourcePopover.tsx";

const EventResourceCell: FC<IAgGridCellProps> = (props) => {
  const myResources = useMemo(() => {
    if (props.data?.results) {
      // initial case when the table is loaded just with the resource types and counts
      return getPlaybookEventResourcesSummary(props.data.results);
    }
    return [];
  }, [props.data]);

  if (!props.value || !props.data) {
    return null;
  }
  const { colDef, context } = props;
  const data: PlaybookEvent = props.data;

  // job results case
  if (data.job) {
    if (data.job.resultCount) {
      const value = `${data.job.resultCount} ${pluralizeWord("BLAST result", data.job.resultCount)}`;
      return (
        <TableCell>
          <SmartLink to={`/job/${data.job.id}/results`} tooltip={value}>
            {value}
          </SmartLink>
        </TableCell>
      );
    }
    return null;
  }

  const items: ListCellItem[] = Object.entries(myResources).map(([categoryName, resources]) => {
    const resourceCount = resources.length;
    const resourceLabel = `${resourceCount} ${pluralizeWord(categoryName, resourceCount)}`;
    return {
      value: <EventResourcePopover resourcesLabel={resourceLabel} eventId={props.data.id} category={categoryName} />,
      tooltip: resourceLabel,
    };
  });

  return (
    <TableCell>
      <ListCellContent items={items} colDef={colDef} context={context} style={{ height: SUBROW_HEIGHT }} />
    </TableCell>
  );
};

export default EventResourceCell;
